export const useErrorMessage = (errors, field) => {
  return (
    <p className="mt-1 text-xs text-red-600 dark:text-red-500">
      {errors?.[field]?.map((msg, index) => {
        return <span key={index}>{msg}</span>;
      })}
    </p>
  );
};
